import { connect } from 'react-redux'
import ParticipantsPanel from './ParticipantsPanel'
import { State } from '../../dataStore/reducers/reducerType'
import selectObservers from '../../dataStore/selectors/selectObservers'
import selectSeatingOrder from '../../dataStore/selectors/selectSeatingOrder'
import { ParticipantsPanelProps } from './types'
import { addMissingUserToParticipantsDetails } from'../../dataStore/actions/room/room'
import getPresentersFromSeatingOrder from '../../dataStore/selectors/getPresentersFromSeatingOrder'

type DispatchProps = 'addMissingUserToParticipantsDetails'

const mapStateToProps = (state: State): Omit<ParticipantsPanelProps, DispatchProps> => ({
  debug: state.config.debug,
  identity: state.config.username,
  presenters: getPresentersFromSeatingOrder(state),
  observers: selectObservers(state),
  participantInformation: state.room.participantInformation,
  seatingOrder: selectSeatingOrder(state),
  maxPresenters: state.config.maxPresenters
})

const mapDispatchToProps = dispatch => ({
 addMissingUserToParticipantsDetails: () => dispatch(addMissingUserToParticipantsDetails())
})

export default connect(mapStateToProps, mapDispatchToProps)(ParticipantsPanel)

